import { instance, instanceStampotheque } from './axiosConfig'
import { joinOwnerWithComma, downloadLink } from './utils'
import { v4 as uuidv4 } from 'uuid'

export default {
  // Call api and create a blob of the result
  // Then create a file.zip and download it.
  async downloadShooting(shootingId, registration, date, imageType) {
    const url = `/API/V1/stampothequeV2/shootings/${shootingId}/zip?type=${imageType}`
    const fileName = `${date.replace(/\//gi, '-')}-${registration}.zip`

    try {
      const res = await instanceStampotheque.get(url, { responseType: 'arraybuffer' })
      const blob = new Blob([res.data], { type: 'octet/stream' })

      downloadLink(blob, fileName)

      return res
    } catch (err) {
      return false
    }
  },

  // Get all stamp for a user
  async getStampsFromStampotheque(userId) {
    const url = `/API/V1/stampothequeV2/users/${userId}/stamps`

    const res = await instanceStampotheque.get(url)

    return res
  },

  async getTokenRoomLive(userId, roomName) {
    let name

    if (!userId) {
      const local = localStorage.getItem('identityName')

      if (!local) {
        const uuid = uuidv4()
        localStorage.setItem('identityName', uuid)
        name = uuid.toString
      } else {
        name = local.toString()
      }
    } else {
      name = userId.toString()
    }

    let url = `/videos/live/token?identity=${name}&room=${roomName}`

    try {
      return await instance.get(url)
    } catch (e) {
      return null
    }
  },

  async createRoomLive(body) {
    const url = '/videos/live/rooms'

    try {
      return await instance.post(url, body)
    } catch (e) {
      return null
    }
  },

  async getRoomLive(userId) {
    const url = `/users/${userId}/videos/live/rooms`

    try {
      return await instance.get(url)
    } catch (e) {
      return null
    }
  },

  async getRoomInformations(idLiveVideo) {
    const url = `/videos/live/rooms/${idLiveVideo}`

    try {
      return await instance.get(url)
    } catch (e) {
      return null
    }
  },

  async getLogoFromRoomLive(liveVideoId) {
    const url = `API/V1/videos/live/${liveVideoId}/options`

    try {
      return await instanceStampotheque.get(url)
    } catch (e) {
      return null
    }
  },

  async playerRating(data) {
    const url = `API/V1/panorama-shootings/scorings`

    try {
      return await instanceStampotheque.post(url, data)
    } catch (e) {
      return null
    }
  },

  async liveVideoRating(data) {
    const url = `API/V1/videos/live/scorings`

    try {
      return await instanceStampotheque.post(url, data)
    } catch (e) {
      return null
    }
  }
}
